import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { bonuses, CHECKOUT_LABEL, volumes } from '../../data/content';

/** The offer and the only checkout button (the only place the price appears). */
export function CheckoutSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-52" data-mp="1osx6swo0p6by">
      <div className="mx-auto max-w-3xl rounded-[28px] bg-brand-plum-dark px-6 py-12 text-center text-white shadow-[0_50px_100px_-50px_rgba(59,27,87,0.7)] sm:px-12 lg:py-16" data-id="element-53" data-mp="2mgxghhfadau7">
        <h2 id="offer-heading" className="mx-auto max-w-xl font-display text-[2.4rem] font-bold leading-[1.04] sm:text-[3.1rem]" data-id="element-54" data-mp="2ci7xtmfkfmcw">
          Combien vaut <em className="font-semibold italic text-brand-lilac" data-id="element-55" data-mp="28gcwihxmx8z4">une heure de votre temps</em> ?
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[16px] leading-relaxed text-white/75 sm:text-[17px]" data-id="element-56" data-mp="110yhv9vnbcgc">
          Arrêtez de passer vos soirées à préparer le cours du lendemain.
        </p>

        <div className="mx-auto mt-10 rounded-[20px] bg-brand-ivory px-6 py-7 text-left text-brand-charcoal sm:px-8" data-id="element-57" data-mp="30jb8spda830t">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-58" data-mp="35f8jaf1v6f5o">
            Vous recevez :
          </p>

          <p className="mt-5 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-59" data-mp="2vi3x4f80qjov">
            6 volumes principaux
          </p>
          <ul className="mt-3 space-y-2.5" role="list" data-id="element-60" data-mp="2miqp7qzjm369">
            {volumes.map(volume => <IncludedItem key={volume.number} label={`Volume ${volume.number}`} title={volume.title} data-id="element-61" data-mp="27tuipyd4wy7r" />)}
          </ul>

          <p className="mt-6 border-t border-brand-charcoal/10 pt-5 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-62" data-mp="2ctyz7oe1lsxz">
            <span className="text-brand-gold" data-id="element-63" data-mp="1yv8yzzvxfd5e">+</span> 5 bonus
          </p>
          <ul className="mt-3 space-y-2.5" role="list" data-id="element-64" data-mp="23rpr1568ybnr">
            {bonuses.map(bonus => <IncludedItem key={bonus.number} label={bonus.number} title={bonus.title} data-id="element-65" data-mp="9dlll1h8ddr3" />)}
          </ul>
        </div>

        <div id="offer-cta" className="scroll-mt-24" data-id="element-66" data-mp="4jhdug0551oy">
          <CtaBlock label={CHECKOUT_LABEL} action="checkout" tone="light" note="Paiement unique • Accès immédiat • Sans abonnement" className="mt-10" data-id="element-67" data-mp="3vsn1a97q5xcc" />
        </div>
      </div>
    </section>;
}
function IncludedItem({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <li className="flex items-start gap-3 text-[15px] leading-snug" data-id="element-68" data-mp="ja6rrq4zkuwi">
      <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-lavender" data-id="element-69" data-mp="j8dkc8mju6ng">
        <CheckIcon className="h-3 w-3 text-brand-plum" strokeWidth={3} aria-hidden="true" data-id="element-70" data-mp="edgch510a3c5" />
      </span>
      <span data-id="element-71" data-mp="33y2yejffhof3">
        <span className="font-semibold" data-id="element-72" data-mp="2z1m93lwht40f">{label} — </span>
        <span className="text-brand-charcoal/75" data-id="element-73" data-mp="2yzrpqc0vdjyg">{title}</span>
      </span>
    </li>;
}